export var KYCStatus;
(function (KYCStatus) {
    KYCStatus["NEW"] = "NEW";
    KYCStatus["REQUIRED"] = "REQUIRED";
    KYCStatus["IN_PROGRESS"] = "IN_PROGRESS";
    KYCStatus["MANUAL_REVIEW"] = "MANUAL_REVIEW";
    KYCStatus["CLOSED"] = "CLOSED";
})(KYCStatus || (KYCStatus = {}));
export const isKycInFlight = (status) => status === KYCStatus.NEW || status === KYCStatus.IN_PROGRESS;
export var KYCResult;
(function (KYCResult) {
    KYCResult["PENDING"] = "PENDING";
    KYCResult["SUCCESS"] = "SUCCESS";
    KYCResult["DECLINED"] = "DECLINED";
})(KYCResult || (KYCResult = {}));
export var KYCProvider;
(function (KYCProvider) {
    KYCProvider["POSTIDENT"] = "POSTIDENT";
})(KYCProvider || (KYCProvider = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["RESULT_PDF"] = "RESULT_PDF";
    DocumentType["DOCUMENT_PHOTO"] = "DOCUMENT_PHOTO";
    DocumentType["SELFIE_PHOTO"] = "SELFIE_PHOTO";
    DocumentType["VIDEO_RECORDING"] = "VIDEO_RECORDING";
    DocumentType["ADDITIONAL_DOCUMENT"] = "ADDITIONAL_DOCUMENT";
})(DocumentType || (DocumentType = {}));
export var LlmVerificationStatus;
(function (LlmVerificationStatus) {
    LlmVerificationStatus["SUCCESS"] = "SUCCESS";
    LlmVerificationStatus["FAILED"] = "FAILED";
})(LlmVerificationStatus || (LlmVerificationStatus = {}));
//# sourceMappingURL=kyc.types.js.map